import { render, staticRenderFns } from "./cDocumentActivityDetails.vue?vue&type=template&id=5bf38b91&scoped=true"
import script from "./cDocumentActivityDetails.vue?vue&type=script&lang=js"
export * from "./cDocumentActivityDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf38b91",
  null
  
)

export default component.exports